export default function EtradeHeroTextData() {
  return [
    {
        title: "Disability Insurance",
        subtitle: "Easy online experience",
        subtitleExtended: "See your coverage options in minutes without the wait*"
    },
    {
        title: "Disability Insurance",
        subtitle: "Extensive choice and convenience",
        subtitleExtended: "Instantly get and compare quotes from top-rated carriers."
    },
    {
        title: "Disability Insurance",
        subtitle: "Disability insurance that’s right for you",
        subtitleExtended: "Easily assess your needs to determine the right term and amount of coverage"
    },
    {
        title: "Disability Insurance",
        subtitle: "In-person help is always available",
        subtitleExtended: "Get assistance via phone from Covr’s licensed specialists in all 50 states"
    }
  ]
}